import { LocalStorageKeys } from '../constants'

class _LocalStorageService {
    setAccepted(newAccepted) {
        localStorage.setItem(LocalStorageKeys.ACCEPTED, JSON.stringify(newAccepted))
    }

    setRejected(newRejected) {
        localStorage.setItem(LocalStorageKeys.REJECTED, JSON.stringify(newRejected))
    }

    setAnonFeedbackId(newId) {
        localStorage.setItem(LocalStorageKeys.ANON_FEEDBACK_ID, JSON.stringify(newId))
    }

    getAccepted() {
        return JSON.parse(localStorage.getItem(LocalStorageKeys.ACCEPTED))
    }

    getRejected() {
        return JSON.parse(localStorage.getItem(LocalStorageKeys.REJECTED))
    }

    getAnonFeedbackId() {
        return JSON.parse(localStorage.getItem(LocalStorageKeys.ANON_FEEDBACK_ID))
    }

    getSiderCollapsed() {
        return JSON.parse(localStorage.getItem(LocalStorageKeys.SIDER_COLLAPSED))
    }

    setSiderCollapsed(collapsed) {
        localStorage.setItem(LocalStorageKeys.SIDER_COLLAPSED, JSON.stringify(collapsed))
        // Dispatch custom event to notify useLocalStorage hook of the change
        window.dispatchEvent(new CustomEvent('localStorageChange', {
            detail: { key: LocalStorageKeys.SIDER_COLLAPSED, value: collapsed }
        }))
    }

    getGroupByTypeForQuestionPage() {
        return JSON.parse(localStorage.getItem(LocalStorageKeys.GROUP_BY_TYPE_FOR_QUESTION_PAGE))
    }

    setGroupByTypeForQuestionPage(groupByType) {
        localStorage.setItem(LocalStorageKeys.GROUP_BY_TYPE_FOR_QUESTION_PAGE, JSON.stringify(groupByType))
    }

    getLastVisitedAssignmentVersion(token) {
        const lastVisitedAssignmentVersion = JSON.parse(
            localStorage.getItem(LocalStorageKeys.LAST_VISITED_ASSIGNMENT_VERSIONS),
        )
        if (lastVisitedAssignmentVersion) return lastVisitedAssignmentVersion[token]
    }

    updateLastVisitedAssignmentVersion(token, versionId) {
        let lastVisitedAssignmentVersions = JSON.parse(
            localStorage.getItem(LocalStorageKeys.LAST_VISITED_ASSIGNMENT_VERSIONS),
        )
        if (lastVisitedAssignmentVersions) {
            lastVisitedAssignmentVersions[token] = versionId
        } else {
            lastVisitedAssignmentVersions = {
                [token]: versionId,
            }
        }

        localStorage.setItem(
            LocalStorageKeys.LAST_VISITED_ASSIGNMENT_VERSIONS,
            JSON.stringify(lastVisitedAssignmentVersions),
        )
    }

    // Canonical read method for last visited review context
    getLastVisitedReviewContext(token, versionId) {
        const store = JSON.parse(localStorage.getItem(LocalStorageKeys.LAST_VISITED_SUBMISSIONS))
        if (!store) return undefined
        const tokenBucket = store[token]
        if (!tokenBucket) return undefined
        const value = tokenBucket[String(versionId)]
        if (typeof value === 'object' && value !== null) return value
        if (value) return { submissionId: value, questionId: undefined }
        return undefined
    }

    // Canonical write method for last visited review context
    updateLastVisitedReviewContext(token, versionId, { submissionId, questionId }) {
        let store = JSON.parse(localStorage.getItem(LocalStorageKeys.LAST_VISITED_SUBMISSIONS))
        if (!store) store = {}

        if (!store[token]) store[token] = {}
        store[token][String(versionId)] = { submissionId, questionId }

        localStorage.setItem(LocalStorageKeys.LAST_VISITED_SUBMISSIONS, JSON.stringify(store))
    }

    getDraftInstantFeedbackSolution(token) {
        const draftInstantFeedbackSolution = JSON.parse(
            localStorage.getItem(LocalStorageKeys.DRAFT_INSTANT_FEEDBACK_SOLUTIONS),
        )
        if (draftInstantFeedbackSolution) return draftInstantFeedbackSolution[token]
    }

    updateDraftInstantFeedbackSolution(token, solution) {
        let draftInstantFeedbackSolutions = JSON.parse(
            localStorage.getItem(LocalStorageKeys.DRAFT_INSTANT_FEEDBACK_SOLUTIONS),
        )
        if (draftInstantFeedbackSolutions) {
            draftInstantFeedbackSolutions[token] = solution
        } else {
            draftInstantFeedbackSolutions = {
                [token]: solution,
            }
        }

        localStorage.setItem(
            LocalStorageKeys.DRAFT_INSTANT_FEEDBACK_SOLUTIONS,
            JSON.stringify(draftInstantFeedbackSolutions),
        )
    }

    getRecentAssignments() {
        return JSON.parse(localStorage.getItem(LocalStorageKeys.RECENT_ASSIGNMENTS)) || []
    }

    updateRecentAssignment({ token, name, language, layerId }) {
        // Skip storing if required fields are missing
        if (!token || !name || !language || layerId === undefined) {
            return
        }

        const recentAssignments = this.getRecentAssignments()
        const filtered = recentAssignments.filter(a => a.token !== token)
        const newEntry = { token, name, language, layerId, accessedAt: Date.now() }
        const updated = [newEntry, ...filtered].slice(0, 5)
        localStorage.setItem(LocalStorageKeys.RECENT_ASSIGNMENTS, JSON.stringify(updated))
    }
}

const LocalStorageService = new _LocalStorageService()
export default LocalStorageService
